export * from './PaymentForm';
export { default as CCForm } from './CCForm';



// WEBPACK FOOTER //
// ./src/components/functional/payments/index.js